// @ts-expect-error TS6192 -- MIGRATION: not approved, fix when encountered
import {
  ACCOUNT_NOT_ACTIVE_ERROR,
  ACCOUNT_LOCKED_ERROR,
  INTERNAL_SERVER_ERROR,
  CREDENTIALS_NOT_VALID_ERROR,
  ACCOUNT_NOT_VERIFIED_ERROR,
} from '../../utils/constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { getUserFriendlyErrorMessage, errorCodes, getAPIErrorMessage } from '../../utils/errormessages'
import { LOGOUT } from '../auth/AuthConstants'
import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR } from './HomeConstants'

const initialState = {
  accessToken: '',
  error: '',
  loading: false,
  defaultServerErrorMessage: '',
}

export const homeReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case LOGIN:
      return {
        error: '',
        loading: true,
        defaultServerErrorMessage: '',
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case LOGIN_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        message = getAPIErrorMessage(action.payload.ErrorCode)
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
